import { c as _c } from "react/compiler-runtime";
import { Chip, ChipGroup, ChipGroupProps, ChipProps, Tooltip } from '@mantine/core';
import { match } from 'ts-pattern';
import { WrapIf } from 'shared/ui';
import { twMerge } from 'tailwind-merge';
export type ChipRadioGroupItem<T extends string> = {
  readonly label?: React.ReactNode;
  readonly value: T;
  readonly tip?: React.ReactNode;
};
export const ChipRadioGroup = t0 => {
  const $ = _c(24);
  let chipProps;
  let items;
  let onChange;
  let props;
  let renderLabel;
  let value;
  if ($[0] !== t0) {
    ({
      items,
      renderLabel,
      chipProps,
      value,
      onChange,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = chipProps;
    $[2] = items;
    $[3] = onChange;
    $[4] = props;
    $[5] = renderLabel;
    $[6] = value;
  } else {
    chipProps = $[1];
    items = $[2];
    onChange = $[3];
    props = $[4];
    renderLabel = $[5];
    value = $[6];
  }
  let t1;
  if ($[7] !== onChange) {
    t1 = v => onChange(v as T);
    $[7] = onChange;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  let t2;
  if ($[9] !== chipProps || $[10] !== items || $[11] !== renderLabel) {
    let t3;
    if ($[13] !== chipProps || $[14] !== items.length || $[15] !== renderLabel) {
      t3 = (item, i) => <WrapIf key={item.value} if={item.tip != null} wrap={c => <Tooltip label={item.tip}><div>{c}</div></Tooltip>}><Chip key={item.value} value={item.value} size="sm" {...chipProps} styles={{
          ...chipProps?.styles,
          iconWrapper: {
            display: "none"
          }
        }} classNames={{
          ...chipProps?.classNames,
          label: twMerge((chipProps?.classNames as any)?.label, match(i).with(0, _temp).with(items.length - 1, _temp2).otherwise(_temp3))
        }}>{renderLabel ? renderLabel(item) : item.label}</Chip></WrapIf>;
      $[13] = chipProps;
      $[14] = items.length;
      $[15] = renderLabel;
      $[16] = t3;
    } else {
      t3 = $[16];
    }
    t2 = items.map(t3);
    $[9] = chipProps;
    $[10] = items;
    $[11] = renderLabel;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  let t3;
  if ($[17] !== t2) {
    t3 = <div className="flex items-center gap-0">{t2}</div>;
    $[17] = t2;
    $[18] = t3;
  } else {
    t3 = $[18];
  }
  let t4;
  if ($[19] !== props || $[20] !== t1 || $[21] !== t3 || $[22] !== value) {
    t4 = <ChipGroup {...props} value={value} onChange={t1}>{t3}</ChipGroup>;
    $[19] = props;
    $[20] = t1;
    $[21] = t3;
    $[22] = value;
    $[23] = t4;
  } else {
    t4 = $[23];
  }
  return t4;
};
function _temp() {
  return "!rounded-r-none";
}
function _temp2() {
  return "!rounded-l-none";
}
function _temp3() {
  return "!rounded-none";
}